import { createRoutine } from 'redux-saga-routines';

import extendRoutine from 'utils/extendRoutines';

import { GET_EMPLOYEE, EDIT_EMPLOYEE, UPDATE_PASSPORT } from './constants';

export const getEmployeeDetail = extendRoutine(createRoutine(GET_EMPLOYEE), 'RESET');
export const editEmployee = extendRoutine(createRoutine(EDIT_EMPLOYEE), 'RESET');
export const updatePassport = extendRoutine(createRoutine(UPDATE_PASSPORT), 'RESET');
